import React from "react";
import Navigator from "pages/Navigator.js";

import "./App.css";

function App() {
  return (
    <div className="App">
      <Navigator />
    </div>
  );
}

export default App;
